var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
import * as Actions from "office/reports/leads/actions";
import * as Selector from "office/reports/leads/selector";
// Components
import LeadsReportView from "office/reports/leads/LeadsReportView";
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import ReportDatePicker from "common/ui/components/datePicker/ReportDatePicker";
// Utils
import NamingHelper from "common/utils/namingHelper";
import DateHelper from "common/utils/DateHelper";
import * as ServerPaths from "common/utils/serverPaths";
import * as reportHelper from "common/utils/reportHelper";
const mapStateToProps = (state, props) => ({
    report: Selector.reportSelector(state)
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch)
});
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
let OfficeLeadsReportView = class OfficeLeadsReportView extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // Only fetch data if we need to
        if (reportHelper.getIfNeedsOfficeData(this.props.params.officeId, this.props.report)) {
            this.props.actions.getForced(this.props.params.officeId);
        }
    }
    render() {
        let { report } = this.props;
        let { reportData } = report;
        let isFetching = report.isFetching;
        let items = [];
        let fromDate = null;
        let toDate = null;
        let officeId = -1;
        if (report.reportData) {
            fromDate = reportData.startDate;
            toDate = reportData.endDate;
            officeId = reportData.officeId;
        }
        if (!report.isFetching) {
            items = reportData.items;
        }
        //-- Handle date change
        let datePick = (fromDate, toDate) => {
            this.props.actions.getForced(report.reportData.officeId, fromDate, toDate, false);
        };
        let ranges = {
            'Yesterday': DateHelper.getYesterday(),
            'Last 7 Days': DateHelper.getLast7Days(),
            'Last 30 Days': DateHelper.getLast30Days(),
            'This Month': DateHelper.getThisMonth(),
            'Last Month': DateHelper.getLastMonth()
        };
        let datePickerComponent = (React.createElement(ReportDatePicker, { fromDate: fromDate, toDate: toDate, isFetching: isFetching, dateRange: ranges, onSelect: (from, to) => datePick(from, to) }));
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: NamingHelper.officeMessageLeads, datePicker: datePickerComponent },
                React.createElement("a", { target: "_blank", href: ServerPaths.officeLeadsRequestCsvParams(officeId, fromDate, toDate) }, "Export")),
            React.createElement(PageContainer, { isFetching: isFetching },
                React.createElement(LeadsReportView, { items: items }))));
    }
};
OfficeLeadsReportView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], OfficeLeadsReportView);
export default OfficeLeadsReportView;
